export function createAiChat(chatConfig) {
    let component;
    let parent;
    let chatApi;
    return {
        init,
        getChatApi,
        destroy,
    };
    function getChatApi() {
        return chatApi;
    }
    async function init() {
        if (component) {
            throw new Error('Need to call destroy() before 2nd init');
        }
        component = createComponent();
        await component.create();
        parent = document.body.appendChild(document.createElement('div'));
        parent.style.height = '0px';
        parent.style.width = '0px';
        parent.dataset.testid = 'constructor-ai-chat';
        component.mount(parent);
        if (component.getStatus() === 'error') {
            destroy();
            throw new Error('Failed to init fragment');
        }
        chatApi = await chatConfig.federationRoot.invokeHandler({
            handlerName: 'getAiChatApi',
            fragmentName: 'knowledge-center',
            entryName: 'chatWidgetInternal',
            componentName: 'chatWidgetInternal',
        });
        if (!chatApi) {
            destroy();
            throw new Error('chatApi is not set. This is a bug in "knowledge-center" fragment');
        }
        return chatApi;
    }
    function createComponent() {
        return chatConfig.federationRoot
            .createFragment({ name: 'knowledge-center' })
            .createComponent({ entryName: 'chatWidgetInternal', componentName: 'chatWidgetInternal' });
    }
    function destroy() {
        component?.unmount();
        component?.destroy();
        parent?.remove();
        parent = undefined;
        chatApi = undefined;
    }
}
//# sourceMappingURL=aiChat.js.map